module.exports = __webpack_public_path__ + "graphics/badge-description-background.ckh.fe756b38bb138a36aa95b93d10cd3145.svg";